import { selector } from '@poa/state';
import moment from 'moment';
import { extendMoment } from 'moment-range';

extendMoment(moment);

const colorEnum = {
  error: '#FFAEAC',
  warn: '#FFEFB2',
  complete: 'initial'
};

const calculateState = {
  error: 2,
  warn: 1,
  complete: 0
};

function calculateRateForLetters(patterns, total) {
  if (patterns < 2) {
    return calculateState.error;
  }

  if (total < 1000) {
    return calculateState.error;
  }

  if (patterns <= 2) {
    return calculateState.warn;
  }

  if (patterns < 4) {
    return calculateState.warn;
  }

  if (total <= 1000) {
    return calculateState.warn;
  }

  if (total < 3000) {
    return calculateState.warn;
  }

  return calculateState.complete;
}

function calculateRateForChats(patterns, total) {
  if (patterns < 2) {
    return calculateState.error;
  }

  if (total < 2000) {
    return calculateState.error;
  }

  if (patterns <= 2) {
    return calculateState.warn;
  }

  if (patterns < 4) {
    return calculateState.warn;
  }

  if (total <= 2000) {
    return calculateState.warn;
  }

  if (total < 5000) {
    return calculateState.warn;
  }

  return calculateState.complete;
}

function isEmpty({ patterns, total }) {
  if (!patterns || !total) {
    return true;
  }

  // empty state
  if (patterns === '-' || total === '-') {
    return true;
  }

  return false;
}

function createRateCalculator(calculatorToApply) {
  return data => {
    const patterns = data.patterns;
    const total = data.total;

    if (isEmpty(data)) {
      return null;
    }

    return calculatorToApply(patterns, total);
  };
}

export function calculateColor(data, currentTime) {
  const chatsCalculator = createRateCalculator(calculateRateForChats);
  const lettersCalculator = createRateCalculator(calculateRateForLetters);

  // if it is same day -> no color
  if (+data.day === currentTime.date()) {
    return colorEnum.complete;
  }

  // calculate all blocks
  const states = [chatsCalculator(data.chat), lettersCalculator(data.letters)];
  const stateIsEmpty = state => state === null;

  // all blocks are empty -> no color
  if (states.every(stateIsEmpty)) {
    return colorEnum.complete;
  }

  // one block is empty -> red color
  if (states.some(stateIsEmpty)) {
    return colorEnum.error;
  }

  // grab max detected severity
  switch (Math.max(...states)) {
    case calculateState.error: // max block severity 2 -> red
      return colorEnum.error;
    case calculateState.warn: // max block severity 1 -> yellow
      return colorEnum.warn;
    default:
      return colorEnum.complete; // both blocks fine -> no color
  }
}

export const daysToShow = selector(store => {
  const range = moment.range(
    store.plugin.filters.startDate.startOf('day'),
    store.plugin.filters.endDate.startOf('day')
  );

  return Array.from(range.by('days')).map(date => date.date());
});

export const usersData = selector(store => {
  const currentDate = moment();

  return store.plugin.data.users
    .slice()
    .sort()
    .map(userId => {
      const data = store.plugin.data.data[userId];

      return {
        userId,
        data: data.map(item => ({ ...item, color: calculateColor(item, currentDate) }))
      };
    });
});
